import { render, staticRenderFns } from "./FolderPathPopup.vue?vue&type=template&id=60f13366&"
import script from "./FolderPathPopup.vue?vue&type=script&lang=ts&"
export * from "./FolderPathPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports